import { render, staticRenderFns } from "./BusinessSummary.vue?vue&type=template&id=760239d8&scoped=true"
import script from "./BusinessSummary.vue?vue&type=script&lang=js"
export * from "./BusinessSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760239d8",
  null
  
)

export default component.exports